var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconGitHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "0.44407cm",
    height: "0.44432cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 10.11 10.12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M-0 5.15c0,2.02 1.21,4.03 2.98,4.76 0.13,0.05 0.25,0.12 0.39,0.16 0.19,0.06 0.32,-0.03 0.4,-0.04l0.03 -1.06c-0.64,0.08 -1.3,0.16 -1.67,-0.62 -0.6,-1.24 -0.72,-0.65 -0.78,-1.11 0.6,-0.13 0.85,0.29 1.1,0.66 0.22,0.32 0.88,0.61 1.33,0.26 0.07,-0.11 0.08,-0.24 0.14,-0.37 0.03,-0.08 0.04,-0.07 0.09,-0.15 0.08,-0.11 0.06,-0.06 0.11,-0.18 -1.52,-0.16 -2.28,-0.95 -2.28,-2.55 0,-0.75 0.26,-0.94 0.51,-1.41 -0.14,-0.51 -0.1,-0.9 0.07,-1.36 0.88,-0.03 1.12,0.6 1.51,0.51 0.84,-0.19 1.44,-0.19 2.27,-0 0.37,0.08 0.59,-0.52 1.51,-0.51 0.24,0.71 0.1,0.73 0.08,1.41 0.24,0.34 0.44,0.62 0.48,1.19 0.08,0.92 -0.19,1.84 -0.97,2.33 -0.35,0.22 -0.83,0.37 -1.3,0.4 0.1,0.22 0.12,0.12 0.22,0.4 0.33,0.96 -0.31,2.51 0.52,2.22 0.69,-0.24 1.21,-0.6 1.71,-1.07 0.66,-0.62 1.3,-1.54 1.52,-2.63 0.09,-0.43 0.14,-0.78 0.13,-1.23 -0.01,-1.07 -0.31,-2 -0.86,-2.87l-0.5 -0.65c-0.29,-0.36 -1.05,-0.89 -1.46,-1.1 -3.24,-1.66 -7.3,0.71 -7.3,4.61z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconGitHub);
export default __webpack_public_path__ + "static/media/homeIconGitHub.c0635fcbde5f30b4d7c4687570d31fff.svg";
export { ForwardRef as ReactComponent };